export const GET_PROPERTY_LABELS_PATH = 'api/landlord/properties/labels';
